module.exports = __webpack_public_path__ + "static/media/editIcon.8e8d3321.svg";